import {
  buildCalendarVisitSchedule,
  createCalendarVisitSchedule
} from '../calendarVisitSchedule.schema';
import { shouldIncludeAsVisitPrescriptionScheduleCooperative } from './shouldIncludeAsVisitPrescriptionScheduleCooperative';
import { transformPadPrescriptionsToPrescriptionLoadSchedule } from './transformPadPrescriptionsToPrescriptionLoadSchedule';

/**
 * Transforms a single padVisit into a genericVisit structure.
 * Pure function with no side effects.
 */
export const transformPadVisitToVisitPrescriptionScheduleCooperative = (padVisit = {}) => {
  if (!shouldIncludeAsVisitPrescriptionScheduleCooperative(padVisit)) return [];

  const { padPrescriptions = [] } = padVisit;
  const prescriptionLoadSchedule = transformPadPrescriptionsToPrescriptionLoadSchedule(
    padPrescriptions,
    padVisit
  );

  return createCalendarVisitSchedule({
    ...buildCalendarVisitSchedule({ ...padVisit }),
    prescriptionLoadSchedule
  });
};
